<template>
  <div class="p-login-form">
    <form id="loginForm" action="/api/login/terms/">
      <div class="p-login-terms" @scroll="onTextScroll">
        <h2 class="p-login-terms__title">「PUSH ONE」利用規約</h2>
        <div class="p-login-terms__text" v-html="renderContent">
        </div>
      </div>
      <ul class="p-login-form-list">
        <li class="p-login-form-list__item ">
          <div class="c-checkbox u-w180">
            <label class="c-checkbox__label">
              <input
                v-model="agreementCheckBox"
                type="checkbox"
                name="is_agree"
                value="1"
              />
              <div class="c-checkbox__item">
                <div class="c-checkbox__box"></div>
                <div class="c-checkbox__box-label">利用規約に同意する</div>
              </div>
            </label>
            <div class="c-error u-w220">
              <div class="c-error__text"></div>
            </div>
          </div>
        </li>
        <li class="p-login-form-list__item">
          <a
            class="c-btn u-w250"
            :class="[isRead ? '' : 'disabled',isRead ? 'c-btn--blue' : 'c-btn--gray']"
            href="#"
            @click="submit($event)"
          >
            <p class="c-btn__text">ログイン</p>
          </a>
        </li>
      </ul>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import MarkdownIt from 'markdown-it';

export default {
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      agreementCheckBox: null,
      isRead: false,
    }
  },
  computed: {
    renderContent: function () {
      return new MarkdownIt().render(this.content);
    },
  },
  methods: {
    onTextScroll: function(e) {
      if(!this.isRead){
        const { scrollTop, offsetHeight, scrollHeight } = e.target;
        if ((scrollTop + offsetHeight) >= scrollHeight) {
          this.isRead = true;
        }
      }
    },
    showErrorMessage: function(elementName,message){
      console.log('error ' + elementName + ' ' + message);
      // エラーメッセージ表示設定
      var loginForm = $('#loginForm');
      loginForm.find('input[name=' + elementName + ']')
        .closest('li')
        .find('.c-error')
        .addClass('is-active')
        .find('.c-error__text')
        .text(message)
      loginForm.find('.c-input').addClass('is-error');
    },
    submit: function (event) {
      event.preventDefault();

      if(!this.isRead){
        this.showErrorMessage('is_agree','利用規約をすべて読んでください');
        return ;
      }

      var loginButton = $('a[name="login"]');
      var loginForm = $('#loginForm');

      // ローディング表示設定
      loginButton.addClass('is-loading').prop('disabled', 'disabled');

      (loginForm.find('input[name=is_agree]'));
      var isAgree = 0;
      if(this.agreementCheckBox){
        isAgree = 1;
      }

      const data = {
        is_agree: isAgree,
      };

      var self = this;
      // 利用規約同意処理実行
      axios.post(loginForm.prop('action'), data)
        .then(res => {
          if (res.data.result == 'OK') {
            location.href = "/coins-admin";
          } else {
            loginButton.removeClass('is-loading').prop('disabled', '');
            if (res.data.errors) {
              for (let elementName in res.data.errors) {
                let message = res.data.errors[elementName];
                self.showErrorMessage(elementName,message);
              }
            }
          }
        })
        .catch(_e => {
          // エラーメッセージ表示設定
          loginForm.find('input[name=is_agree]')
            .closest('li')
            .find('.c-error')
            .addClass('is-active')
            .find('.c-error__text')
            .text('予期せぬエラーが発生しました');
        });
    },
  }
}
</script>

<style lang="scss">
.p-login-terms__text {
    ol {
        counter-reset: parent-counter;
    }

    ul > li {
        padding-left: 0em;
        &::before {
            content: "・";
        }
    }

    ol > li {
        counter-increment: parent-counter;
        list-style-type: none;
        padding-bottom: 8px;
        text-indent: -1.4em;
        padding-left: 1.5em;

        &::before {
            content: "(" counter(parent-counter) ")";
        }

        > ol {
            margin-top: 8px;
            counter-reset: child-counter;
        }

        > ul > li {
            padding-left: 1.5em;
            &::before {
                content: "・";
            }
        }
    }

    ol > li > ol > li {
        counter-increment: child-counter;
        list-style-type: none;

        &::before {
            content: "(" counter(child-counter) ")";
        }
    }
}
</style>
